import { Box } from '@chakra-ui/react';
import React from 'react';

export const LoadingSpinner: React.FC = () => (
  <Box
    width="24px"
    height="24px"
    borderRadius="full"
    bg="var(--bg-secondary, #F7F7F7)"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Box
      width="6px"
      height="6px"
      border="1.5px solid"
      borderColor="var(--border, #E0E0E0)"
      borderTop="transparent"
      borderRight="transparent"
      transform="rotate(-45deg)"
      animation="pulse 2s ease-in-out infinite"
    />
  </Box>
);
